export default __webpack_public_path__ + "static/media/toShow-4-min.50046928.jpg";